import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container, Alert, Card } from 'react-bootstrap';
import AuthContext from '../Components/AuthContext';
import api from '../services/api';

const Login = () => {
  const { handleLogin } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await api.post('users/login/', {
        email: email.trim(),
        password: password,
      });

      const { success, username, display_name, token, last_login, is_admin, can_view_activity } = response.data;

      if (success) {
        handleLogin(username || email, token, last_login, display_name || username || email);
        localStorage.setItem('token', token);
        localStorage.setItem('Token', token);
        localStorage.setItem('lastLoggedIn', last_login);
        localStorage.setItem('is_admin', is_admin ? 'true' : 'false');
        localStorage.setItem('can_view_activity', can_view_activity ? 'true' : 'false');
        navigate('/');
      } else {
        setError('Invalid email or password');
      }
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Card className="shadow-lg border-0" style={{ width: '100%', maxWidth: '400px' }}>
        <Card.Body className="p-4">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">Welcome Back</h2>
            <p className="text-muted">Sign in to your account</p>
          </div>

          <Form onSubmit={handleLoginSubmit}>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label className="fw-semibold">Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="py-2"
              />
            </Form.Group>

            <Form.Group className="mb-4" controlId="password">
              <Form.Label className="fw-semibold">Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="py-2"
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 fw-semibold"
              disabled={isLoading}
            >
              {isLoading ? 'Signing In...' : 'Sign In'}
            </Button>
          </Form>

          {error && (
            <Alert variant="danger" className="mt-3 mb-0">
              {error}
            </Alert>
          )}

          <div className="text-center mt-4">
            <Button
              variant="link"
              onClick={() => navigate('/forgot-password')}
              className="text-decoration-none p-0"
            >
              Forgot your password?
            </Button>
          </div>

          <hr className="my-4" />

          <div className="text-center">
            <span className="text-muted">Don't have an account? </span>
            <Button
              variant="outline-secondary"
              onClick={() => navigate('/signup')}
              className="ms-2"
              size="sm"
            >
              Sign Up
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;
